import { createAction } from 'redux-actions'

import { RIDER_SAVING } from './rider'

export const SET_ALERT = createAction('SET_ALERT')
export const CLEAR_ALERT = createAction('CLEAR_ALERT')
export const CLEAR_ALL_ALERTS = createAction('CLEAR_ALL_ALERTS')

export const setAlert = (message = '', link = undefined, type = undefined, status = undefined) => {
  return (dispatch) => {
    if (type) dispatch(RIDER_SAVING({type}))

    dispatch(SET_ALERT({message, link, type, status}))
  }
}

export const clearAlert = (index) => {
  return (dispatch) => {
    dispatch(RIDER_SAVING())

    dispatch(CLEAR_ALERT({index}))
  }
}

export const clearAllAlerts = () => {
  return (dispatch) => {
    dispatch(CLEAR_ALL_ALERTS())
  }
}



// WEBPACK FOOTER //
// ./src/actions/alerts.js